import { useCallback, useEffect, useMemo, useState } from "react";

import { updateUser } from "../../../../services/apiUser";
import useMutate from "../../../../hooks/useMutate";

export function useUserMutationDialog({
  userId,
  initialValue,
  createPayload,
  getNextValue,
  invalidateKeys = ["users"],
}) {
  const [value, setValue] = useState(initialValue);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const { mutate } = useMutate(
    updateUser,
    invalidateKeys,
    () => {},
    () => {
      setValue((previousValue) => getNextValue(previousValue));
      setIsSubmitting(false);
      closeDialog();
    },
    () => {
      setIsSubmitting(false);
      closeDialog();
    }
  );

  const openDialog = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const submit = useCallback(() => {
    setIsSubmitting(true);
    mutate({
      id: userId,
      data: createPayload(value),
    });
  }, [createPayload, mutate, userId, value]);

  return useMemo(
    () => ({
      value,
      isDialogOpen,
      isSubmitting,
      openDialog,
      closeDialog,
      submit,
    }),
    [closeDialog, isDialogOpen, isSubmitting, openDialog, submit, value]
  );
}
